"use strict";

if (!customElements.get("s-sort-modal")) {
  customElements.define(
    "s-sort-modal",
    class extends HTMLElement {
      connectedCallback() {
        this.overlay = this.querySelector(".js-sort-modal__overlay");
        this.modal = this.querySelector(".js-sort-modal__modal");
        this.closeButton = this.querySelector(".js-sort-modal__close");
        this.form = this.querySelector(".js-sort-modal__form");
        this.inputs = Array.from(this.querySelectorAll(".js-sort-modal__input"));

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleSortInputChange = this.handleSortInputChange.bind(this);

        if (this.overlay) {
          this.overlay.addEventListener("click", this.closeModal);
        }

        if (this.closeButton) {
          this.closeButton.addEventListener("click", this.closeModal);
        }

        this.inputs.forEach((input) => input.addEventListener("change", this.handleSortInputChange));

        if (window.PubSub && typeof window.PubSub.subscribe === "function") {
          this.openModalUnsubscriber = window.PubSub.subscribe("open-sort", this.openModal);
        }
      }

      disconnectedCallback() {
        if (this.overlay) {
          this.overlay.removeEventListener("click", this.closeModal);
        }

        if (this.closeButton) {
          this.closeButton.removeEventListener("click", this.closeModal);
        }

        this.inputs.forEach((input) => input.removeEventListener("change", this.handleSortInputChange));

        if (this.openModalUnsubscriber) {
          this.openModalUnsubscriber();
        }
      }

      openModal() {
        if (this.overlay) {
          this.overlay.classList.add("is-active");
        }

        if (this.modal) {
          this.modal.classList.add("is-active");
        }

        document.body.classList.add("sort-modal--is-active");
      }

      closeModal(event) {
        if (event) {
          event.preventDefault();
        }

        if (this.overlay) {
          this.overlay.classList.remove("is-active");
        }

        if (this.modal) {
          this.modal.classList.remove("is-active");
        }

        document.body.classList.remove("sort-modal--is-active");
      }

      handleSortInputChange() {
        if (this.form) {
          this.form.submit();
        }
      }
    }
  );
}
